import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import {
  ClientConfigurationRequest,
  ClientConfigurationResponse,
} from '../../client.model';

@Component({
  selector: 'app-client-configuration-form',
  imports: [ReactiveFormsModule, ...SharedMaterialUIModule],
  templateUrl: './client-configuration-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientConfigurationFormComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly clientId = input.required<string>();
  readonly initialValue = input<ClientConfigurationResponse | null>(null);
  readonly saving = input(false);
  readonly submitted = output<ClientConfigurationRequest>();

  readonly configurationForm = this.formBuilder.group({
    logo: [''],
    notificationEmail: ['', Validators.email],
    maxNumberOfDependents: [null as number | null],
    canAccessClientPortal: ['false', Validators.required],
    faceToFaceCasesAllowed: [null as number | null],
    telephonicCasesAllowedPercentageOfHeadcount: [null as number | null],
    sessionsAllowedPerCase: [null as number | null],
  });

  constructor() {
    effect(() => {
      const initialValue = this.initialValue();
      if (initialValue) {
        this.configurationForm.patchValue({
          logo: initialValue.logo ?? '',
          notificationEmail: initialValue.notificationEmail ?? '',
          maxNumberOfDependents: initialValue.maxNumberOfDependents,
          canAccessClientPortal: String(initialValue.canAccessClientPortal),
          faceToFaceCasesAllowed: initialValue.faceToFaceCasesAllowed,
          telephonicCasesAllowedPercentageOfHeadcount: initialValue.telephonicCasesAllowedPercentageOfHeadcount,
          sessionsAllowedPerCase: initialValue.sessionsAllowedPerCase,
        });
      }
    });
  }

  protected onSubmit(): void {
    if (this.configurationForm.invalid) {
      return;
    }

    const value = this.configurationForm.getRawValue();
    this.submitted.emit({
      clientId: this.clientId(),
      logo: value.logo?.trim() ? value.logo : null,
      notificationEmail: value.notificationEmail?.trim() ? value.notificationEmail : null,
      maxNumberOfDependents: value.maxNumberOfDependents,
      canAccessClientPortal: value.canAccessClientPortal === 'true',
      faceToFaceCasesAllowed: value.faceToFaceCasesAllowed,
      telephonicCasesAllowedPercentageOfHeadcount: value.telephonicCasesAllowedPercentageOfHeadcount,
      sessionsAllowedPerCase: value.sessionsAllowedPerCase,
    });
  }
}